/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { ShopifyOrderImportOrderResultDtoModel, ShopifyOrderImportOrderResultDtoModelType } from "./ShopifyOrderImportOrderResultDtoModel"
import { ShopifyOrderImportOrderResultDtoModelSelector } from "./ShopifyOrderImportOrderResultDtoModel.base"
import { ShopifyOrderImportSummaryDtoModel, ShopifyOrderImportSummaryDtoModelType } from "./ShopifyOrderImportSummaryDtoModel"
import { ShopifyOrderImportSummaryDtoModelSelector } from "./ShopifyOrderImportSummaryDtoModel.base"
import { SkippedShopifyOrderDtoModel, SkippedShopifyOrderDtoModelType } from "./SkippedShopifyOrderDtoModel"
import { SkippedShopifyOrderDtoModelSelector } from "./SkippedShopifyOrderDtoModel.base"
import { RootStoreType } from "./index"


/**
 * ImportShopifyOrdersResultDtoBase
 * auto generated base class for the model ImportShopifyOrdersResultDtoModel.
 */
export const ImportShopifyOrdersResultDtoModelBase = ModelBase
  .named('ImportShopifyOrdersResultDto')
  .props({
    __typename: types.optional(types.literal("ImportShopifyOrdersResultDto"), "ImportShopifyOrdersResultDto"),
    jobId: types.union(types.undefined, types.string),
    status: types.union(types.undefined, types.string),
    summary: types.union(types.undefined, types.late((): any => ShopifyOrderImportSummaryDtoModel)),
    orders: types.union(types.undefined, types.array(types.late((): any => ShopifyOrderImportOrderResultDtoModel))),
    errorCode: types.union(types.undefined, types.null, types.string),
    createdCount: types.union(types.undefined, types.integer),
    skippedCount: types.union(types.undefined, types.integer),
    skippedOrders: types.union(types.undefined, types.array(types.late((): any => SkippedShopifyOrderDtoModel))),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class ImportShopifyOrdersResultDtoModelSelector extends QueryBuilder {
  get jobId() { return this.__attr(`jobId`) }
  get status() { return this.__attr(`status`) }
  get errorCode() { return this.__attr(`errorCode`) }
  get createdCount() { return this.__attr(`createdCount`) }
  get skippedCount() { return this.__attr(`skippedCount`) }
  summary(builder: string | ShopifyOrderImportSummaryDtoModelSelector | ((selector: ShopifyOrderImportSummaryDtoModelSelector) => ShopifyOrderImportSummaryDtoModelSelector) | undefined) { return this.__child(`summary`, ShopifyOrderImportSummaryDtoModelSelector, builder) }
  orders(builder: string | ShopifyOrderImportOrderResultDtoModelSelector | ((selector: ShopifyOrderImportOrderResultDtoModelSelector) => ShopifyOrderImportOrderResultDtoModelSelector) | undefined) { return this.__child(`orders`, ShopifyOrderImportOrderResultDtoModelSelector, builder) }
  skippedOrders(builder: string | SkippedShopifyOrderDtoModelSelector | ((selector: SkippedShopifyOrderDtoModelSelector) => SkippedShopifyOrderDtoModelSelector) | undefined) { return this.__child(`skippedOrders`, SkippedShopifyOrderDtoModelSelector, builder) }
}
export function selectFromImportShopifyOrdersResultDto() {
  return new ImportShopifyOrdersResultDtoModelSelector()
}

export const importShopifyOrdersResultDtoModelPrimitives = selectFromImportShopifyOrdersResultDto().jobId.status.errorCode.createdCount.skippedCount
